import { ReleasePlanServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import {  getLocalStorage, setLocalStorage } from "@/utils/storage";
import { notification } from 'ant-design-vue'
import dayjs from 'dayjs'

var timer = null

export async function openNotification() { // 判断是否需要展示
  const releasePlan = getLocalStorage('release-plan') // 从local中获取release-plan 值
  if(releasePlan.start && releasePlan.end){ // 判断是否存在开始和结束时间
    const accepted = getLocalStorage('release-plan-accepted') // 从local中获取release-plan-accepted 是否已读标识符值
    const now = dayjs().valueOf() // 获取当前时间
    const start = Number(releasePlan.start)
    const end = Number(releasePlan.end)
    if(start < now && now < end && accepted === '0'){
      setLocalStorage('release-plan-accepted', '1')
      notification.warning({
        message: '版本发布通知！',
        duration: 120,
        key: 'masterlink-version-show',
        style:{
          backgroundColor: '#fff7e6',
          boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.25)',
          borderRadius: '2px',
          border: 'solid 1px #ffa940',
          fontSize: '14px'
        },
        description: releasePlan.message,
      })
    }
  }
}

export async function closeNotify() {
  notification.close('masterlink-version-show')
}

export async function checkReleasePlan() { // 判断是否需要重新加载数据
  const releasePlan = getLocalStorage('release-plan') // 从local中获取release-plan 值
  if(releasePlan){ // 判断是否存在开始和结束时间
    const now = dayjs().valueOf() // 获取当前时间
    const end = Number(releasePlan.end)
    if(!end || (end && end < now)){  // 当当前时间大于发布结束时间，重新获取下次发布时间
      // 防止统一时间段多次请求
      if(timer) {
        clearTimeout(timer)
        timer = null
      }
      timer = setTimeout(() => {
        setPromptTime()
      }, 5000);
    }
  }
}

export async function getPromptTime(){
  const rpsp = new ReleasePlanServiceProxy()
  const data = await rpsp.getReleasePlan()
  let prompt = {
    start: '',
    end: '',
    message: ''
  }
  if(data) {
    prompt.start = data.planStartTime ? dayjs(data.planStartTime).format('YYYY-MM-DD HH:mm:ss') : ''
    prompt.end =  data.planEndTime ? dayjs(data.planEndTime).format('YYYY-MM-DD HH:mm:ss'): ''
    prompt.message = data.remark
  }
  return prompt
}

export async function setPromptTime() {
  const data = await getPromptTime()
  let localValue = {
    start: '',
    end: '',
    message: ''
  }
  localValue.start = dayjs(data.start).valueOf() + ''
  localValue.end = dayjs(data.end).valueOf() + ''
  localValue.message = data.message
  const releasePlan = getLocalStorage('release-plan')
  if(!releasePlan){
    setLocalStorage('release-plan',localValue)
    setLocalStorage('release-plan-accepted','0')
  } else {
    const localStart = dayjs(Number(releasePlan.start)).valueOf() + ''
    const localEnd = dayjs(Number(releasePlan.end)).valueOf() + ''
    if(localEnd !== localValue.end || localValue.start !== localStart){
      setLocalStorage('release-plan',localValue)
      setLocalStorage('release-plan-accepted','0')
    }
  }
  openNotification()
}
